const CancerHistory = [
  { value: "Unilateral", name: "Unilateral" },
  { value: "Bilateral", name: "Bilateral" },
];

export default CancerHistory;
